var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`m-3 wrapper wrapper--border wrapper--default`},[_c('span',{staticClass:"m-1"},[_vm._v("Full cache clear: "),_c('button',{staticClass:"employee_download",on:{"click":_vm.clearCache}},[_vm._v("Clear Cache")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }